import React, {useRef, useState} from "react";
import {IFilter} from "../../interface/Basic/window";
import {useOnClickOutside} from "../../hooks/useClickOutside";
import {DateSelect, DateSelectorBody, SelectHeader, SelectItem} from "../../components/ui/Content";
import {Body1} from "../../components/Font";
import {DropDown, DropUp} from "../../icon/Icon";
import { useBodyLock } from "../../hooks/useBodyLock";


interface FormSelectProps {
    items: IFilter[]
    selectedItem?: string
    onSelect: (value: IFilter) => void
    placeholder: string
    className?: string
}

export const DateSelector = ({items, onSelect, selectedItem, placeholder, className}: FormSelectProps) => {

    const [opened, setOpened] = useState(false)
    const ref = useRef<HTMLDivElement>(null);
    useOnClickOutside(ref, () => setOpened(false));
    useBodyLock(opened);
    return <DateSelect>
        <SelectHeader
            className={className}
            onClick={() => setOpened(prevState => !prevState)}>
            <Body1>{selectedItem ?? placeholder}</Body1>
            {opened ? <DropUp/> : <DropDown/>}
        </SelectHeader>
        {opened && <DateSelectorBody ref={ref}>

            {items.map((item, index) => (
                <SelectItem onClick={() => {
                    onSelect(item)
                    setOpened(false)
                }} key={index}>
                    <Body1>
                        {item.name}
                    </Body1>
                </SelectItem>
            ))
            }
        </DateSelectorBody>}
    </DateSelect>
}